import React from 'react';
import { clsx } from 'clsx';
import { faCircle, faCircleDot, faSquare } from '@fortawesome/pro-regular-svg-icons';
import { faCheckSquare } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flexbox from '@/components/common/Flexbox';
const Check: React.FC<{
  variant?: 'circle' | 'square';
  checked?: boolean;
  outerClassName?: string;
  innerClassName?: string;
}> = ({
  variant = 'circle',
  checked = false,
  outerClassName,
  innerClassName
}) => {
  return <Flexbox align={'center'} justify={'center'} className={clsx(outerClassName ? outerClassName : 'w-5 h-5')} data-sentry-element="Flexbox" data-sentry-component="Check" data-sentry-source-file="Check.tsx">
      <FontAwesomeIcon icon={variant === 'circle' ? checked ? faCircleDot : faCircle : checked ? faCheckSquare : faSquare} className={clsx(innerClassName, checked ? 'text-primary' : 'text-grey4')} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="Check.tsx" />
    </Flexbox>;
};
export default Check;